import { useEffect, useState } from 'react';
import { cn, ModuleProperties, useLocaleStore } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';
import { getPopularSearches, getSections } from '@/services/platform/data/shop/catalog';
import { SectionContentResponseModel } from '@/services/platform/api/model';
import { ShopSearch } from '@/components/shared/shop/search';

export const ShopSearchApi = (props: ModuleProperties) => {
  const locale = useLocaleStore(state => state.locale);
  const [sections, setSections] = useState<SectionContentResponseModel[] | undefined>(undefined);

  const popular = getPopularSearches(props?.context?.settings);

  useEffect(() => {
    getSections(props?.context?.settings, locale, true).then(setSections);
  }, [props?.context?.settings, locale]);

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__shop-product-list']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex flex-col flex-1 gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      <ShopSearch sections={sections} popular={popular} context={props.context} />
    </ModuleWrapper>
  );
};
